import { render, staticRenderFns } from "./subprogram-nba-page.vue?vue&type=template&id=f400a534&scoped=true&"
import script from "./subprogram-nba-page.vue?vue&type=script&lang=js&"
export * from "./subprogram-nba-page.vue?vue&type=script&lang=js&"
import style0 from "./subprogram-nba-page.vue?vue&type=style&index=0&id=f400a534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f400a534",
  null
  
)

export default component.exports